import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';

@inject(({
  store,
}) => (
  {
    store,
  }
))
class Empty extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    store: PropTypes.shape({
      initialLoadComplete: PropTypes.bool,
    }),
  };

  UNSAFE_componentWillMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener ?
        window.addEventListener('load', () => {
          this.props.store.initialLoadComplete = true;
        }, false) :
        window.attachEvent && window.attachEvent('onload', () => {
          this.props.store.initialLoadComplete = true;
        });
    }
  }

  render() {
    const {children} = this.props;

    return (React.Children.only(children));
  }
}

export default Empty;



// WEBPACK FOOTER //
// ./spa/Pages/Empty.jsx